<div class="addNewPolicyContainer">
    <!-- <div class="Loading" *ngIf="isShowLoading==true">
                <img id="" src="assets/img/762.gif"   />
              <label>{{'Please Wait,Processing..'|translate }}</label>
        </div> -->

    <div class="Loading" *ngIf="isShowLoading==true">
        <div class="loader"></div>
        <!-- <img id="" src="assets/img/762.gif"   /> -->
        <label class="loaderlabel">Please wait while Processing....</label>
    </div>




    <div class="Clears"></div>
</div>


<div class="container-fluid">
    <div class="MyProposalForm disForm seoLandingPage">
        <div class="col-lg-5 col-md-5 hidden-sm hidden-xs">
            <div class="car_bg">

                <div class="Description">

                    <img src="assets/theme/en/images/4.png">
                    <h3>{{'Motor Insurance' |translate }}</h3>
                    <!-- <span>{{'Template data need to provide by ACIG' | translate }}</span>

                    <ul>
                        <li>XXXX XXXXXXX XXXXXXXX XXXXXX</li>
                        <li>XXX XXXXXXXXXX XXXXXX XXXXXXXXX</li>
                        <li>XXXXXXX XXXXXXX XXXXXXXX XXXXXX</li>
                        <li>XXXXX XXXXXXX XXXXXXXXX XXXXXXXX</li>
                        <li>XXX XXXXXXXX XXXXXXXXXX XXXXXXXXX</li>
                   
                    </ul> -->
                </div>
                <i class="fa fa-angle-right arrows"></i>
            </div>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
            <form #NewPolicyForm="ngForm">
                <div class="CarForm">
                    <div class="InsuredInformation Infomation">

                        <div class="FormSection">

                            <div class="Clears"></div>
                            <div class="radiProposal">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"></div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <span>
                                            <!--(ngModelChange)="abcd(newPolicyReq.productType)"-->
                                            <input type="radio" name="PolicyType" id="ptype1" value="0000"
                                                [(ngModel)]="newPolicyReq.productType" style="zoom: 125%;">
                                            <label class="lbltext">{{'Both TPL and Comprehesnisve'|translate }}</label>
                                        </span>
                                        <span>
                                            <input type="radio" name="PolicyType" id="ptype2" value="5520"
                                                [(ngModel)]="newPolicyReq.productType" style="zoom: 125%;">
                                            <label class="lbltext">{{'Comprehesnisve Only' | translate }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="Field">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label class="lbltext">{{'Vehicle Definition Type' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <select class="form-control" id="txtVDT" name="txtVDT" required
                                            [(ngModel)]="newPolicyReq.VDT"
                                            (ngModelChange)="SetTransferOfOwnerShip(newPolicyReq.VDT)">
                                            <option value="2">{{'Sequence No' | translate }}</option>
                                            <option value="3">{{'Custom Id' | translate }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="Field">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label class="lbltext">{{'ID Number' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <input class="form-control" required id="txtIqmaNo" name="txtIqamaNo"
                                            placeholder="Iqama No" type="text" [(ngModel)]="newPolicyReq.IqamaNoforDis"
                                            [disabled]="true">
                                    </div>
                                </div>
                            </div>



                            <div class="Field" *ngIf="newPolicyReq.VDT=='2'">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label class="lbltext">{{'Sequence No' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <input class="form-control" numbersOnly minlength="6" maxlength="9"
                                            [required]="newPolicyReq.VDT=='2'" pattern="^[0-9][0-9]{5,8}$"
                                            placeholder="{{'Sequence No'|translate}}" type="text" id="txtSeqNo"
                                            name="txtSeqNo" [(ngModel)]="newPolicyReq.SequenceNo" #txtSeqNo="ngModel">
                                        <span *ngIf="txtSeqNo.errors && (txtSeqNo.dirty || txtSeqNo.touched)"
                                            class="text-danger valid">
                                            <p *ngIf="txtSeqNo.errors?.required">
                                                {{'Sequence No is required'| translate }}</p>
                                            <p *ngIf="txtSeqNo.errors?.pattern && txtSeqNo.invalid && txtSeqNo.touched">
                                                {{'Sequence No must be 6 to 9 digits' | translate }} </p>
                                        </span>
                                    </div>
                                </div>
                            </div>



                            <div class="Field" *ngIf="newPolicyReq.VDT=='3'">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label class="lbltext">{{'Custom Id'| translate }}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <input class="form-control" maxlength="10" minlength="10"
                                            [required]="newPolicyReq.VDT=='3'" pattern="^[1-9][0-9]{9}$"
                                            placeholder="{{'Custom Id'|translate}}" type="text" numbersOnly
                                            id="txtCustomID" name="txtCustomID" [(ngModel)]="newPolicyReq.CustomID"
                                            #txtCustomID="ngModel">
                                        <span *ngIf="txtCustomID.errors && (txtCustomID.dirty || txtCustomID.touched)"
                                            class="text-danger valid">
                                            <p *ngIf="txtCustomID.errors?.required">
                                                {{'Custom ID is required' | translate }}</p>
                                            <p
                                                *ngIf="txtCustomID.errors?.pattern && txtCustomID.invalid && txtCustomID.touched">
                                                {{'CustomID must be 10 digits and not start with Zero' | translate }}
                                            </p>
                                        </span>

                                    </div>
                                </div>
                            </div>

                            <!-- <div class="Field" class="Field" *ngIf="newPolicyReq.VDT=='3'">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label class="lbltext">{{'Custom ID Issuence Date' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <input class="form-control" maxlength="10" minlength="10"
                                            [required]="newPolicyReq.VDT=='3'" name="txtCustDate" id="txtCustDate"
                                            placeholder="{{'Custom ID Issuence Date'|translate}}"
                                            pattern="^([1-9]|(0|1|2)[0-9]|30)(/|-)([1-9]|1[0-2]|0[1-9])(/|-)((13|14|15)[0-9]{2})$"
                                            type="text" [(ngModel)]="newPolicyReq.CustomIssuenceDate"
                                            #txtCustDate="ngModel" HijriPicker>
                                        <span *ngIf="txtCustDate.errors && (txtCustDate.dirty || txtCustDate.touched)"
                                            class="text-danger valid">
                                            <p *ngIf="txtCustDate.errors?.required">
                                                {{'Custom ID Issuence Date is required'| translate }}</p>
                                            <p
                                                *ngIf="txtCustDate.errors?.pattern && txtCustDate.invalid && txtCustDate.touched">
                                                {{'Invalid Hijri Date(dd/MM/yyyy)'| translate }}</p>
                                        </span>

                                    </div>
                                </div>
                            </div> -->



                            <div class="Field" class="Field" *ngIf="newPolicyReq.VDT=='3'">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label class="lbltext">{{'Model Year' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <select class="form-control" id="txtVDT" name="txtVDT" required
                                            [(ngModel)]="newPolicyReq.VehicleModelYear" required
                                            name="ddlVehicleModelYear" id="ddlVehicleModelYear"
                                            #ddlVehicleModelYear="ngModel">
                                            <option value="">--{{'Select Model Year'| translate }}--</option>
                                            <option *ngFor="let year of Years" [value]="year">{{year}}</option>
                                        </select>
                                        <span
                                            *ngIf="ddlVehicleModelYear.errors && (ddlVehicleModelYear.dirty || ddlVehicleModelYear.touched)"
                                            class="text-danger valid">
                                            <p *ngIf="ddlVehicleModelYear.errors?.required">
                                                {{'Vehicle ModelYear is required'| translate }}</p>
                                            <p
                                                *ngIf="ddlVehicleModelYear.errors?.pattern && ddlVehicleModelYear.invalid && ddlVehicleModelYear.touched">
                                                {{'Vehicle ModelYear is required'| translate }}</p>
                                        </span>
                                    </div>

                                </div>
                            </div>




                            <div class="" *ngIf="disableTOS">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <label class="transfer">
                                            <input type="checkbox" id="txtTOS" name="txtTOS"
                                                [(ngModel)]="newPolicyReq.isTransferOfShip" />

                                            &nbsp;{{'Transfer of OwnerShip' | translate }}</label>


                                    </div>
                                </div>
                            </div>

                            <div class="Field" *ngIf="newPolicyReq.isTransferOfShip">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label class="lbltext">{{'Owner ID Number' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <input class="form-control" numbersOnly pattern="^[127][0-9]{9}$" minlength="10"
                                            maxlength="10" [required]="newPolicyReq.isTransferOfShip"
                                            id="txtOwnerIqamaNo" name="txtOwnerIqamaNo" placeholder="Owner Iqama No"
                                            type="text" [(ngModel)]="newPolicyReq.OwnerIqamaNo"
                                            #txtOwnerIqamaNo="ngModel">
                                        <span
                                            *ngIf="txtOwnerIqamaNo.errors && (txtOwnerIqamaNo.dirty || txtOwnerIqamaNo.touched)"
                                            class="text-danger valid">
                                            <p *ngIf="txtOwnerIqamaNo.errors?.required">
                                                {{'Owner ID Number is required' | translate }}</p>
                                            <p
                                                *ngIf="txtOwnerIqamaNo.errors?.pattern && txtOwnerIqamaNo.invalid && txtOwnerIqamaNo.touched">
                                                ID Number Must start with 1 or 2 or 7 and It must be 10 digits </p>
                                        </span>

                                    </div>
                                </div>
                            </div>




                        </div>






                        <!-- Button Actions -->

                        <div class="Actionsection">
                            <div class="Actions">
                                <div class="btn-group">

                                    <button type="button" name="txtBUY" id="txtBUY" class="btn btn-primary btns"
                                        [disabled]="!NewPolicyForm.valid"
                                        (click)="BUYPolicy()">{{'PROCEED'| translate}}</button>

                                </div>
                            </div>
                        </div>
                        <div class="Clears"></div>


                        <div class="Field">
                            <div class="row">

                                <div class="alert alert-danger" role="alert" *ngIf="isError">
                                    {{ Lng=="ar" ? newPolicyRes.st.StatusDescAr : newPolicyRes.st.StatusDesc}}
                                </div>



                            </div>
                        </div>



                    </div>
                </div>
            </form>
        </div>


    </div>
</div>

<div class="PayMethods">

    <img src="assets/img/payment-footer-en1.png">
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/NewProposal/NewProposal.html